var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandMore = function SvgExpandMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.245 5.018a.833.833 0 0 0 0 1.18l5.607 5.607c.26.26.68.26.94 0l5.606-5.607a.833.833 0 0 0 0-1.18.833.833 0 0 0-1.18 0L8.325 9.912l-4.9-4.9a.84.84 0 0 0-1.18.006"
  })));
};
export default SvgExpandMore;